import { ToastContainer } from 'react-toastify';

import withProviders from '@/app/providers';
import { ChatChangesProvider } from '@/app/providers/chat-changes-provider/chat-changes-provider';
import { CompanyProvider } from '@/app/providers/company-provider';
import { DialogProvider } from '@/app/providers/modal-provider/modal-provider.tsx';
import { NotificationsWSProvider } from '@/app/providers/notifications-ws-provider';
import { ThemeProvider } from '@/app/providers/theme-provider';
import Routing from '@/pages';

import { DndCollectorProvider } from './providers/markdown-dnd-collector-provider/markdown-dnd-collector-provider';

const App = () => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <DndCollectorProvider>
        <NotificationsWSProvider>
          <ChatChangesProvider>
            <CompanyProvider>
              <DialogProvider>
                <Routing />
                <ToastContainer />
              </DialogProvider>
            </CompanyProvider>
          </ChatChangesProvider>
        </NotificationsWSProvider>
      </DndCollectorProvider>
    </ThemeProvider>
  );
};

export default withProviders(App);
